<div class="zf-user" (mouseenter)="cancelClose()" (mouseleave)="scheduleClose()">

  <div class="zf-icon-btn" [class.open]="bellOpen()" (click)="toggleBell($event)" title="Notifications">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#62666F" stroke-width="1.7"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.7 21a2 2 0 0 1-3.4 0"></path>
    </svg>
  </div>

  @if (bellOpen()) {
    <div class="zf-menu-panel wide" (click)="$event.stopPropagation()">
      <div class="zf-notes-head">
        <span>Notifications</span>
        <span class="zf-count">0 new</span>
      </div>
      <div class="zf-notes-empty">
        <strong>You're all caught up</strong>
        Alerts for approvals, short receipts and expiring stock will appear here.
      </div>
    </div>
  }

  <div class="zf-user-chip" [class.open]="menuOpen()" (click)="toggleMenu($event)">
    <div class="zf-avatar">{{ initials() }}</div>
    <div class="zf-user-text">
      <span class="zf-user-name">{{ displayName() }}</span>
      <span class="zf-user-role">{{ roleLabel() }}</span>
    </div>
    <span class="zf-caret-sm">{{ menuOpen() ? '⌃' : '⌄' }}</span>
  </div>

  @if (menuOpen()) {
    <div class="zf-menu-panel" (click)="$event.stopPropagation()">
      <div class="zf-menu-hero">
        <div class="zf-avatar-lg">{{ initials() }}</div>
        <div class="d-flex flex-column align-items-center gap-1">
          <span class="zf-hero-name">{{ displayName() }}</span>
          <span class="zf-hero-sub">{{ roleLabel() }} · Zenflow AI ERP</span>
        </div>
        @if (currentStore(); as s) {
          <div class="zf-hero-store">
            <span class="zf-code">{{ s.storeCode }}</span>
            <span>{{ s.locationName || s.storeName }}</span>
          </div>
        }
        <a class="zf-hero-btn" routerLink="/my-account" (click)="closeAll()">Manage your account</a>
      </div>

      <div class="zf-menu-list">
        <a class="zf-menu-item" routerLink="/my-account" (click)="closeAll()">
          <span class="zf-glyph"><i class="bi bi-person"></i></span>My profile
        </a>
        @if (storeCount() > 1) {
          <a class="zf-menu-item" routerLink="/select-store" (click)="closeAll()">
            <span class="zf-glyph"><i class="bi bi-geo-alt"></i></span>Switch location
            <span class="zf-meta">{{ storeCount() }}</span>
          </a>
        }
      </div>

      <div class="zf-menu-list">
        <div class="zf-menu-item accent" (click)="askSignOut()">
          <span class="zf-glyph"><i class="bi bi-box-arrow-right"></i></span>Sign out
        </div>
      </div>
    </div>
  }
</div>

@if (confirmOpen()) {
  <div class="zf-modal-backdrop" (click)="confirmOpen.set(false)">
    <div class="zf-modal" (click)="$event.stopPropagation()">
      <div class="zf-modal-body">
        <div class="zf-modal-icon"><i class="bi bi-box-arrow-right"></i></div>
        <span class="zf-modal-title">Sign out of Zenflow?</span>
        <span class="zf-modal-text">You will need your username and password to get back in. Anything saved stays on the server.</span>
      </div>
      <div class="zf-modal-actions">
        <button type="button" class="btn btnsecondary" (click)="confirmOpen.set(false)">Stay signed in</button>
        <button type="button" class="btn btnprimary" (click)="signOut()">Sign out</button>
      </div>
    </div>
  </div>
}
